import { Radio } from 'antd';
import { FaCog, FaUserCog } from 'react-icons/fa';
import { GiDirectorChair, GiHockey } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import useIsMobile from 'hooks/useIsMobile';
import useLoginStore from 'store/loginStore';

const RoleSelector = () => {
  const hasMultipleRoles = useLoginStore(s => s.hasMultipleRoles)();
  const getAvailableRoles = useLoginStore(s => s.getAvailableRoles);
  const getCurrentRole = useLoginStore(s => s.getCurrentRole);
  const setCurrentRole = useLoginStore(s => s.setCurrentRole);
  const navigate = useNavigate();
  const isMobile = useIsMobile('1000px');   // need to make this bigger for landscape mode

  const handleRoleSwitch = (role) => {
    setCurrentRole(role);
    navigate('/');
  };

  if (!hasMultipleRoles) {
    return;
  }

  const items = [];

  const availableRoles = getAvailableRoles();
  const displayOrder = ['PLAYER', 'TEAM_MANAGER', 'ADMIN', 'SYSTEM_ADMIN'];
  const sortedRoles = [...availableRoles].sort((a, b) => displayOrder.indexOf(a) - displayOrder.indexOf(b));
  const currentRole = getCurrentRole();

  const getRoleLabel = (role) => {
    if (isMobile) {
      // Mobile: show labels for <= 2 roles, icons only for >= 3 roles
      if (sortedRoles.length <= 2) {
        return role === 'TEAM_MANAGER' ? 'Manager' :
          role === 'PLAYER' ? 'Player' :
            role === 'ADMIN' ? 'Org Admin' :
              role === 'SYSTEM_ADMIN' ? 'System Admin' : role;
      } else {
        // Show only icons for 3+ roles on mobile
        return role === 'TEAM_MANAGER' ? <span className="flex items-center justify-center h-full px-2"><GiDirectorChair /></span> :
          role === 'PLAYER' ? <span className="flex items-center justify-center h-full px-2"><GiHockey /></span> :
            role === 'ADMIN' ? <span className="flex items-center justify-center h-full px-2"><FaUserCog /></span> :
              role === 'SYSTEM_ADMIN' ? <span className="flex items-center justify-center h-full px-2"><FaCog /></span> : role;
      }
    } else {
      // Desktop: show only labels
      return role === 'TEAM_MANAGER' ? 'Manager' :
        role === 'PLAYER' ? 'Player' :
          role === 'ADMIN' ? 'Org Admin' :
            role === 'SYSTEM_ADMIN' ? 'System Admin' : role;
    }
  };
  
  sortedRoles.forEach(role => {
    const roleLabel = getRoleLabel(role);

    items.push({
      label: roleLabel,
      value: role,
    });
  });

  return (
    <Radio.Group 
      size={'small'}
      optionType="button"
      buttonStyle="solid"
      options={items}
      value={currentRole}
      onChange={(e) => handleRoleSwitch(e.target.value)}
    />
  )
}

export default RoleSelector